import { alpha, Badge, ButtonBase, styled } from '@mui/material';
import { blue, common, grey } from '@mui/material/colors';

export const ToolbarControlRoot = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'isSquare' && prop !== 'isDisabled',
})(({ isActive, isSquare, isDisabled }: { isActive: boolean; isSquare: boolean; isDisabled: boolean }) => {
  const commonStyles = {
    '&:hover': {
      backgroundColor: grey[100],
    },
  };

  const activeStyles = {
    backgroundColor: blue[500],
    color: common.white,
    '&:hover': {
      backgroundColor: grey[500],
    },
  };

  return {
    position: 'relative',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '4.5rem',
    height: '4.5rem',
    padding: '0.9375rem 0.25rem',
    fontSize: '0.75rem',
    borderRadius: !isSquare ? '0.125rem' : 0,
    opacity: isDisabled ? 0.2 : 1,
    ...(isActive ? activeStyles : commonStyles),
  };
});

export const ToolbarControlIcon = styled('span')(({ isActive }: { isActive: boolean }) => ({
  color: isActive ? common.white : alpha(common.black, 0.54),
  display: 'inline-block',
  marginBottom: '0.125rem',
}));

export const ToolbarControlBadge = styled(Badge)({
  '& .MuiBadge-badge': {
    width: '0.9375rem',
    minWidth: '0.9375rem',
    height: '0.9375rem',
    fontSize: '0.65rem',
  },
});
